
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetolonavalacab() {



    const cardData =
    {
        keyword: 'Pune to Lonavala Cab',
        heading: 'Meghana Cab : Pune to Lonavala Cab',
        headingDescription: 'Meghana Cab offers Pune to Lonavala Cab services, perfect for travelers seeking a quick and comfortable getaway to the scenic hill station. Just 65 kilometers from Pune, Lonavala is known for its lush greenery, waterfalls, and breathtaking viewpoints, making it an ideal weekend destination. Our fleet of well-maintained AC cabs, including sedans, SUVs, and tempo travellers, ensures a safe and relaxing ride through the picturesque Mumbai–Pune Expressway. Whether you’re planning a family picnic, romantic retreat, or corporate trip, Meghana Cab provides punctual pickups, transparent fares, and 24×7 customer assistance. Book your Pune to Lonavala Cab with Meghana Cab for a smooth, affordable, and memorable travel experience.',


        top: 'Top Places to Visit in Lonavala with Meghana Cab',

"topPlaces": [
  {
    "title": "Tiger’s Leap (Tiger Point)",
    "description": "Tiger’s Leap, also known as Tiger Point, is one of Lonavala’s most iconic viewpoints offering dramatic cliffside vistas of the Western Ghats. Perched nearly 650 meters above sea level, it resembles a leaping tiger when viewed from a distance. The site is famous for breathtaking sunrise and sunset views, especially during the monsoon when mist and waterfalls enhance its beauty. Tourists enjoy photography, tea stalls, and the cool mountain breeze here. On clear days, one can spot the lush valleys stretching endlessly. It’s an essential stop for adventure lovers and scenic drive enthusiasts traveling through Lonavala."
  },
  {
    "title": "Bhushi Dam",
    "description": "Bhushi Dam is one of the most beloved monsoon attractions in Lonavala, drawing visitors for its cascading waters and lively atmosphere. Built on the Indrayani River, the dam overflows during rains, creating natural step-like waterfalls where visitors enjoy wading and splashing. Surrounded by green hills, the area becomes a picnic paradise. Vendors serve hot corn and chai as mist drifts over the steps. Safety measures are in place during heavy rains, yet the experience of Bhushi Dam remains unmatched in charm and vibrancy. It’s an unmissable monsoon destination for families and friends."
  },
  {
    "title": "Karla and Bhaja Caves",
    "description": "Dating back over 2,000 years, the Karla and Bhaja Caves are remarkable Buddhist rock-cut shrines nestled in the Sahyadri hills near Lonavala. These ancient caves feature stupas, prayer halls, and exquisite sculptures depicting Buddhist teachings. The Karla Caves are home to one of India’s largest chaityas, while Bhaja Caves display intricate carvings of dancing figures and mythological themes. A short trek leads visitors through scenic trails surrounded by lush greenery. Both sites offer a glimpse into India’s early spiritual architecture and serve as peaceful retreats from the bustling hill town."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort stands majestically amidst the Sahyadri ranges, overlooking the stunning valleys of Lonavala. Comprising twin forts — Shrivardhan and Manaranjan — it has historical significance dating back to the Maratha Empire. The fort offers panoramic views, particularly enchanting during monsoon with floating clouds and waterfalls. Adventure seekers often trek to Rajmachi from Kondane or Lonavala base. The trail passes through lush forests and meadows, making it a favorite among trekkers. The fort’s stone pathways and ancient bastions evoke Maharashtra’s glorious past while offering nature lovers a thrilling escape."
  },
  {
    "title": "Lonavala Lake",
    "description": "Formed by the monsoon rains, Lonavala Lake sits peacefully amidst dense greenery and rolling hills. The lake brims with water during the rainy season and becomes a haven for picnickers, bird watchers, and photographers. Local stalls nearby serve hot pakoras and tea, adding warmth to the breezy atmosphere. The reflection of clouds on the calm waters and chirping of birds create a soothing retreat for nature lovers. During early mornings, mist covers the surroundings, making it ideal for peaceful walks and quiet moments of reflection."
  },
  {
    "title": "Lion’s Point",
    "description": "Lion’s Point offers one of the most spectacular panoramic views in Lonavala, located between Bhushi Dam and Aamby Valley. Known for its rugged cliffs and dramatic landscapes, the point becomes magical during monsoon when dozens of waterfalls cascade down the surrounding hills. The view of clouds floating below your feet is mesmerizing. At night, the point turns into a serene stargazing spot away from city lights. Small roadside eateries serve piping hot tea and snacks, making it a delightful stop for couples, bikers, and photography enthusiasts exploring Lonavala’s heights."
  },
  {
    "title": "Pawna Lake",
    "description": "Pawna Lake, located about 20 km from Lonavala, is a tranquil reservoir surrounded by scenic hills and fort ruins such as Tikona, Lohagad, and Tung. It has become a popular spot for lakeside camping, bonfires, and stargazing. The reflection of twilight over the still waters creates a picture-perfect escape from urban chaos. Visitors can enjoy kayaking, barbeque nights, and nature walks along the shore. Whether you come for a romantic weekend or a group adventure, Pawna Lake offers a memorable blend of serenity and outdoor fun amid Maharashtra’s mountain landscape."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad, meaning ‘Iron Fort’, is a mighty hill fort near Lonavala that once guarded important trade routes during the Maratha rule. The fort is easily accessible and ideal for beginner trekkers. Its winding steps lead to expansive hilltop plateaus offering panoramic views of Pawna Lake and Visapur Fort. Covered in mist during monsoon, the fort transforms into a dreamy landscape. The famous ‘Vinchu Kata’ (scorpion tail-shaped rampart) is a highlight for photographers. Lohagad’s blend of history, adventure, and natural beauty makes it one of the most visited forts in Maharashtra."
  },
  {
    "title": "Wax Museum Lonavala",
    "description": "The Wax Museum in Lonavala, established by sculptor Sunil Kandalloor, showcases lifelike wax statues of national leaders, film stars, sports personalities, and global icons. It provides a fascinating family experience and is one of India’s most popular wax museums outside major metros. Visitors can take photos with figures of Mahatma Gandhi, Sachin Tendulkar, A.P.J. Abdul Kalam, and many more. The museum’s attention to detail and interactive displays make it a fun indoor attraction. It’s a perfect stop for tourists seeking entertainment and creativity amidst Lonavala’s natural splendor."
  },
  {
    "title": "Ekvira Devi Temple",
    "description": "Located near Karla Caves, Ekvira Devi Temple is a sacred shrine dedicated to Goddess Ekvira, the Kuldevi of the Koli and Agri fishing communities. The temple stands atop a hill with 500 stone steps leading to it, offering devotees panoramic views of the valley below. The shrine is especially crowded during Navratri and Chaitra festivals when thousands of devotees gather for blessings. Surrounded by lush greenery, the temple’s peaceful environment and rhythmic chants fill the air with devotion. It’s a must-visit spiritual spot that complements Lonavala’s scenic charm."
  }
],

     "services": [
    {
      "name": "Pune to Lonavala Cab Tour Package",
      "description": "Discover the scenic hill station of Lonavala with Meghana Cab’s Pune to Lonavala cab tour package. Perfect for weekend getaways, family trips, or romantic escapes, our package includes comfortable AC cabs, professional drivers, and flexible itineraries that let you explore famous spots like Bushi Dam, Rajmachi Fort, and Lonavala Lake. Enjoy hassle-free pickups from anywhere in Pune or Pune Airport and experience a smooth ride through the Western Ghats. Our package offers round-trip options, competitive pricing, and premium vehicles including Innova Crysta and Ertiga for a comfortable journey. Book your Pune to Lonavala cab tour package today and enjoy nature’s beauty with Meghana Cab."
    },
    {
      "name": "Pune to Lonavala Taxi Fare",
      "description": "Get transparent and competitive Pune to Lonavala taxi fares with Meghana Cab. Whether you choose a one-way trip or a round trip, we offer clear pricing without hidden charges. Our cab fares vary based on vehicle type—from hatchbacks and sedans to spacious SUVs like Innova Crysta and Ertiga. Enjoy value-for-money services with well-maintained vehicles, courteous drivers, and door-to-door service. Planning your budget-friendly trip to Lonavala is easy with Meghana Cab’s upfront fare estimates. Book now and enjoy a smooth, cost-effective journey from Pune to Lonavala."
    },
    {
      "name": "Pune Airport to Lonavala Cab",
      "description": "Travel conveniently from Pune Airport to Lonavala with Meghana Cab’s dedicated airport transfer services. Avoid taxi hassles and long waits with our pre-booked, reliable cabs. Choose from comfortable vehicles like Innova Crysta, Ertiga, or sedans based on your group size. Our drivers track your flight to ensure timely pickups and provide a smooth, safe ride to Lonavala’s popular destinations. Whether arriving for leisure or business, enjoy stress-free transfers with Meghana Cab’s airport to Lonavala cab service. Book in advance for guaranteed availability and great rates."
    },
    {
      "name": "Pune to Lonavala Taxi Service",
      "description": "Experience hassle-free travel with Meghana Cab’s Pune to Lonavala taxi service, designed for both one-way and round trips. Perfect for sightseeing, business trips, or family outings, our fleet includes well-maintained AC vehicles like Innova Crysta, Ertiga, and sedans to suit every requirement. Our professional drivers ensure timely pickups, safe driving, and courteous service throughout your journey. Whether you’re traveling from Pune city center, Pimpri Chinchwad, or Pune Airport, Meghana Cab offers flexible scheduling and affordable pricing. Book your Pune to Lonavala taxi today and enjoy a comfortable, scenic ride."
    },
    {
      "name": "Pune to Lonavala Cab Booking",
      "description": "Book your Pune to Lonavala cab online with Meghana Cab in just a few clicks. Our user-friendly booking system lets you select the vehicle type, travel date, and pickup location easily. Choose from sedans, SUVs, Innova Crysta, or Ertiga depending on your comfort needs and group size. Enjoy reliable pickups, professional drivers, and transparent pricing with no hidden charges. Our cabs are regularly sanitized and maintained for passenger safety and comfort. Whether for a day trip or overnight stay, Meghana Cab guarantees a hassle-free Pune to Lonavala cab booking experience."
    },
    {
      "name": "Pimpri Chinchwad to Lonavala Cab",
      "description": "Travel from Pimpri Chinchwad to Lonavala smoothly with Meghana Cab’s reliable cab services. Ideal for daily commuters, tourists, and corporate travelers, we offer AC vehicles equipped with modern amenities and experienced drivers familiar with the best routes. Whether you want a quick one-way trip or a round trip, our flexible packages ensure convenient travel at affordable rates. Enjoy door-to-door service, timely pickups, and safe journeys from Pimpri Chinchwad to the scenic hills of Lonavala. Book now to experience the comfort and convenience of Meghana Cab."
    },
    {
      "name": "Pune to Lonavala Innova Crysta",
      "description": "Travel in style and comfort from Pune to Lonavala with Meghana Cab’s Innova Crysta rental service. Perfect for family outings, group trips, or corporate travel, our Innova Crysta vehicles offer spacious seating, advanced safety features, and superior air conditioning for a pleasant journey. Our experienced chauffeurs ensure smooth navigation through the Western Ghats, making your ride relaxing and enjoyable. With flexible booking options and competitive pricing, choose Meghana Cab for your premium Pune to Lonavala Innova Crysta cab rental."
    },
    {
      "name": "Pune to Lonavala Ertiga Cab Booking",
      "description": "Book a comfortable and economical Ertiga cab from Pune to Lonavala with Meghana Cab. Our Ertiga vehicles offer spacious interiors and great fuel efficiency, making them ideal for small groups or families seeking a budget-friendly yet comfortable travel option. Enjoy AC comfort, professional drivers, and timely pickups whether you’re traveling for leisure or business. Flexible round-trip and one-way booking options are available to suit your travel plans. Trust Meghana Cab for safe and affordable Pune to Lonavala Ertiga cab service."
    }
  ],

  "tableData": [
    ["Pune to Lonavala Cab Tour Package", "Pune to Lonavala Taxi Fare"],
    ["Pune Airport to Lonavala Cab", "Pune to Lonavala Taxi Service"],
    ["Pune to Lonavala Cab Booking", "Pimpri Chinchwad to Lonavala Cab"],
    ["Pune to Lonavala Innova Crysta", "Pune to Lonavala Ertiga Cab Booking"],
    ["", ""]
  ],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Lonavala Cab Service",
        "WhyChoosedescription": "Meghana Cab provides comfortable and dependable cab services from Pune to the scenic hill station of Lonavala, perfect for weekend getaways or day trips."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop in Lonavala",
        "WhyChoosedescription": "We ensure prompt pick-ups from Pune and timely drop-offs at any destination in Lonavala, so you can enjoy your trip without worrying about travel delays."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Pune-Lonavala Route",
        "WhyChoosedescription": "Our drivers are well-acquainted with the Pune to Lonavala route and focus on safe, smooth driving to make your journey enjoyable."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Meghana Cab offers competitive pricing for Pune to Lonavala trips with no hidden charges, helping you plan your travel budget effectively."
    },
    {
        "WhyChooseheading": "Clean and Safe Vehicles for Your Comfort",
        "WhyChoosedescription": "Travel in sanitized, well-maintained cabs equipped with essential safety features like GPS tracking and seat belts for a secure ride."
    },
    {
        "WhyChooseheading": "24/7 Cab Service to Lonavala",
        "WhyChoosedescription": "Whether you need an early morning ride or a late return trip, Meghana Cab is available round the clock to accommodate your Pune to Lonavala travel plans."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Choose from one-way or round-trip options and customize your journey with Meghana Cab to fit your schedule and preferences."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Customer Support",
        "WhyChoosedescription": "Book your Pune to Lonavala cab quickly through our website or app. Our support team is always ready to assist with bookings and travel queries."
    }
]






















    }

const faqData = [
    {
        question: "How can I book a Pune to Lonavala cab with Meghana Cab?",
        answer: "You can book a Pune to Lonavala cab easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What cab options are available for travel from Pune to Lonavala?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers depending on your group size and comfort preference."
    },
    {
        question: "Is one-way cab service available from Pune to Lonavala?",
        answer: "Yes, we offer both one-way and round-trip cab services from Pune to Lonavala."
    },
    {
        question: "How long does it take to travel from Pune to Lonavala by cab?",
        answer: "The journey typically takes around 1.5 to 2 hours, depending on traffic conditions."
    },
    {
        question: "Are tolls and taxes included in the cab fare for Pune to Lonavala?",
        answer: "Tolls, parking charges, and taxes are additional and communicated clearly during booking."
    },
    {
        question: "Are Meghana Cab drivers experienced with the Pune to Lonavala route?",
        answer: "Yes, our drivers are professional and familiar with the Pune to Lonavala route."
    },
    {
        question: "Can I request stops or breaks during the Pune to Lonavala journey?",
        answer: "Yes, you can request stops or breaks during the trip by informing us while booking."
    },
    {
        question: "Is the cab service from Pune to Lonavala available at night?",
        answer: "Yes, Meghana Cab offers 24/7 service, including night travel."
    },
    {
        question: "What payment options are accepted for Pune to Lonavala cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How do I contact Meghana Cab to book a Pune to Lonavala cab?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Amit Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune to Lonavala cab service by Meghana Cab was prompt and comfortable. The driver was courteous and the car clean.”',
    },
    {
        name: 'Ms. Sneha Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great experience traveling to Lonavala with Meghana Cab. Smooth ride and excellent customer support.”',
    },
];









































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Cab",
  "description": "Book a Pune to Lonavala Cab with Meghana Cabs for a safe, comfortable, and affordable journey. Enjoy scenic drives and quick getaways with our reliable car rental and taxi services. Perfect for family trips and weekend tours.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4721"
  }
};







    return (
        <div>


<Helmet>
  <title>Pune to Lonavala Cab | Affordable Taxi & Car Rental @ Meghana Cabs</title>
  <meta
    name="description"
    content="Book your Pune to Lonavala cab with Meghana Cabs. Affordable taxi fares, comfortable rides, and reliable service for one-way or round-trip journeys. Book online today!"
  />
  <meta
    name="keywords"
    content="Pune to Lonavala Cab Tour Package, Pune to Lonavala Taxi Fare, Pune airport to lonavala cab, Pune lonavala taxi, Pune to lonavala by car, Pune to lonavala cab booking, Pune to lonavala cab charges, Pune to lonavala cab cost, Pune to lonavala cabs round trip, Pune to lonavala private car rental, Pune to lonavala taxi service, pune to lonavala innova crysta, pune to lonavala ertiga cab booking, pune airport to lonavala innova cabs, pimpri chinchwad to lonavala cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/59.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetolonavalacab;